<template>
  <div>
    <div class="tableau-wrapper row">
      <div class="tableau-body no-type" ref="tableauBody">
        <loading v-if="this.loading" />
        <tableauInvite
          v-if="!this.loading && this.tableauData"
          ref="tableau"
          :tableau-data="tableauData"
          :type-donnees="typeDonnees"
        />
      </div>
      <div class="tableau-tab">
        <tableauTitre
          :tableauDetails="ongletsList"
          @changeOnglet="handleChangeOnglet"
          :read-only="true"
        ></tableauTitre>
      </div>
    </div>
  </div>
</template>
<script>

import tableauInvite from '../../components/tableau/tableauInvite'
import tableauTitre from '../../components/tableau/tableauTitre'
import loading from '../../components/loading'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    tableauInvite,
    tableauTitre,
    loading
  },
  data () {
    return {
      tableauData: {},
      obj: {},
      isReadOnly: null,
      typeDonnees: {},
      isEditable: null,
      ongletsList: [],
      permissions: []
    }
  },
  watch: {
    async currentOnglet (id) {
      this.setLoading(true)
      var obj = {
        onglet: id,
        invit: this.$route.params.idInvitation
      }
      console.log(obj)
      this.tableauData = await this.getInviteTableauData(obj)
      this.setLoading(false)
    }
  },
  async created () {
    const idProject = this.$route.params.idProject
    const idInvitation = this.$route.params.idInvitation
    const token = this.$route.params.tokenInvite

    const payload = {
      projectId: idProject,
      idInvitation: idInvitation,
      token
    }

    this.setLoading(true)
    this.setTypeModule('tableau_surface')
    await this.getInviteListOnglet(payload)
    // await this.getTypeDonnees()

    this.ongletsList = this.listOnglet()
    this.permissions = this.getPermissions()

    if (this.ongletsList[0]) {
      this.setIsLoadedEntityId(false)
      this.setCurrentOnglet(this.ongletsList[0].id)
      await this.setEntityId(this.ongletsList[0].id) // entity id for comment
      this.setIsLoadedEntityId(true)
    }

    var obj = {
      onglet: this.currentOnglet,
      invit: idInvitation
    }

    this.tableauData = await this.getInviteTableauData(obj)

    this.setLoading(false)

    if (this.permissions[this.currentOnglet].is_editable == null && this.permissions[this.currentOnglet].is_viewable) {
      this.tableauData.isReadOnly = true
      this.tableauData.isEditable = false
    } else {
      this.tableauData.isReadOnly = false
      this.tableauData.isEditable = true
    }
  },
  computed: {
    ...mapGetters(['currentOnglet', 'currentProject', 'loading'])
  },
  methods: {
    ...mapGetters(['listOnglet', 'typeModule', 'entityId', 'ficheTableauData', 'getPermissions']),
    ...mapActions(['setInviteToken', 'setIsLoadedComments', 'setIsLoadedEntityId', 'setEntityId', 'setTypeModule', 'getInviteListOnglet', 'setCurrentOnglet', 'getInviteTableauData', 'getTypeDonnees', 'setLoading']),
    async switchTableau (idProjet, idOnglet) {
      this.setEntityId(idOnglet)
      var obj = {
        onglet: this.currentOnglet,
        invit: this.$route.params.idInvitation
      }

      this.tableauData = await this.getInviteTableauData(obj)
      this.setCurrentOnglet(idOnglet)
      await this.getInviteListOnglet(idProjet)
      this.ongletsList = this.listOnglet()
    },
    async handleChangeOnglet (id) {
      this.setCurrentOnglet(id)
      this.setEntityId(id)
    }
  }

}
</script>
<style lang="scss">
.tableau-wrapper {
  height: calc(100vh - 56px);
}
.tableau-body {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 120px);
  /*height: calc(100vh - 93px);*/
  padding-top: 100px;
  // overflow-x: auto;
  .jexcel_content {
    padding-top: 16px;
  }
  &.no-type {
    .jexcel_content {
      padding-top: 0;
    }
  }
  .title-and-search {
    position: fixed;
    background-color: #fff;
    top: 56px;
    z-index: 1001;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }
}
.disabled-action {
  position: relative;
  cursor: not-allowed;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 100;
  }
  button {
    color: #6c757d;
    border-color: #6c757d;
    &.active {
      background-color: #6c757d !important;
    }
  }
}
#tableau {
  .button-box {
    padding-right: 185px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageTableau/readOnlyTableau.vue